import { FormElementKind, FormElementType } from '../../types/formSchema';

export interface FormFieldTypeDefinition {
  type: FormElementType;
  kind: FormElementKind;
  label: string;
  answerType: 'NONE' | 'STRING' | 'NUMBER' | 'BOOLEAN' | 'STRING_ARRAY' | 'FILE_ARRAY';
  supportsRequired: boolean;
  supportsOptions?: boolean;
  supportsOther?: boolean;
  canDriveConditions?: boolean;
}

const define = (definition: FormFieldTypeDefinition): FormFieldTypeDefinition => definition;

export const FORM_FIELD_TYPE_REGISTRY: Record<FormElementType, FormFieldTypeDefinition> = {
  SHORT_TEXT: define({ type: 'SHORT_TEXT', kind: 'QUESTION', label: 'Short text', answerType: 'STRING', supportsRequired: true }),
  LONG_TEXT: define({ type: 'LONG_TEXT', kind: 'QUESTION', label: 'Long text', answerType: 'STRING', supportsRequired: true }),
  NUMBER: define({ type: 'NUMBER', kind: 'QUESTION', label: 'Number', answerType: 'NUMBER', supportsRequired: true, canDriveConditions: true }),
  DATE: define({ type: 'DATE', kind: 'QUESTION', label: 'Date', answerType: 'STRING', supportsRequired: true, canDriveConditions: true }),
  DATE_TIME: define({ type: 'DATE_TIME', kind: 'QUESTION', label: 'Date and time', answerType: 'STRING', supportsRequired: true, canDriveConditions: true }),
  SINGLE_CHOICE: define({
    type: 'SINGLE_CHOICE',
    kind: 'QUESTION',
    label: 'Single choice',
    answerType: 'STRING',
    supportsRequired: true,
    supportsOptions: true,
    supportsOther: true,
    canDriveConditions: true
  }),
  MULTIPLE_CHOICE: define({
    type: 'MULTIPLE_CHOICE',
    kind: 'QUESTION',
    label: 'Multiple choice',
    answerType: 'STRING_ARRAY',
    supportsRequired: true,
    supportsOptions: true,
    supportsOther: true,
    canDriveConditions: true
  }),
  YES_NO: define({ type: 'YES_NO', kind: 'QUESTION', label: 'Yes / No', answerType: 'BOOLEAN', supportsRequired: true, canDriveConditions: true }),
  FILE_UPLOAD: define({ type: 'FILE_UPLOAD', kind: 'QUESTION', label: 'File upload', answerType: 'FILE_ARRAY', supportsRequired: true }),
  EMAIL: define({ type: 'EMAIL', kind: 'QUESTION', label: 'Email', answerType: 'STRING', supportsRequired: true }),
  PHONE: define({ type: 'PHONE', kind: 'QUESTION', label: 'Phone', answerType: 'STRING', supportsRequired: true }),
  URL: define({ type: 'URL', kind: 'CONTENT', label: 'Link', answerType: 'NONE', supportsRequired: false }),
  RATING: define({ type: 'RATING', kind: 'QUESTION', label: 'Rating', answerType: 'NUMBER', supportsRequired: true, canDriveConditions: true }),
  ACKNOWLEDGEMENT: define({
    type: 'ACKNOWLEDGEMENT',
    kind: 'QUESTION',
    label: 'Acknowledgement',
    answerType: 'BOOLEAN',
    supportsRequired: true,
    canDriveConditions: true
  }),
  HEADING: define({ type: 'HEADING', kind: 'CONTENT', label: 'Heading', answerType: 'NONE', supportsRequired: false }),
  PARAGRAPH: define({ type: 'PARAGRAPH', kind: 'CONTENT', label: 'Paragraph', answerType: 'NONE', supportsRequired: false }),
  IMAGE: define({ type: 'IMAGE', kind: 'CONTENT', label: 'Image', answerType: 'NONE', supportsRequired: false }),
  ATTACHMENT: define({ type: 'ATTACHMENT', kind: 'CONTENT', label: 'File attachment', answerType: 'NONE', supportsRequired: false }),
  DIVIDER: define({ type: 'DIVIDER', kind: 'CONTENT', label: 'Divider', answerType: 'NONE', supportsRequired: false }),
  SECTION: define({ type: 'SECTION', kind: 'CONTENT', label: 'Section', answerType: 'NONE', supportsRequired: false }),
  PAGE_BREAK: define({ type: 'PAGE_BREAK', kind: 'PAGE', label: 'Page break', answerType: 'NONE', supportsRequired: false })
};

export const getFormFieldTypeDefinition = (type: FormElementType): FormFieldTypeDefinition =>
  FORM_FIELD_TYPE_REGISTRY[type];
